import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Layout Components
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";

// Pages
import HomePage from "@/pages/HomePage";
import HaloterapiaPage from "@/pages/HaloterapiaPage";
import ServiciosPage from "@/pages/ServiciosPage";
import BeneficiosPage from "@/pages/BeneficiosPage";
import FamiliasPage from "@/pages/FamiliasPage";
import FilosofiaPage from "@/pages/FilosofiaPage";
import BonosPage from "@/pages/BonosPage";
import ContactoPage from "@/pages/ContactoPage";
import AdminPage from "@/pages/AdminPage";
import GiftVoucherPage from "@/pages/GiftVoucherPage";
import { BonoPagoCompletadoPage, BonoPagoErrorPage } from "@/pages/BonoResultPage";
import ReservarPage from "@/pages/ReservarPage";
import { BookingPagoCompletadoPage, BookingPagoErrorPage } from "@/pages/BookingResultPage";
import SignaturePage from "@/pages/SignaturePage";

// Layout wrapper
const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-halo-cream">
      <Navigation />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Admin route without layout */}
          <Route path="/admin" element={<AdminPage />} />
          {/* Public e-signature page (no layout — focused full-screen flow) */}
          <Route path="/firmar/:token" element={<SignaturePage />} />
          
          {/* Public routes with layout */}
          <Route path="/" element={<Layout><HomePage /></Layout>} />
          <Route path="/haloterapia" element={<Layout><HaloterapiaPage /></Layout>} />
          <Route path="/servicios" element={<Layout><ServiciosPage /></Layout>} />
          <Route path="/beneficios" element={<Layout><BeneficiosPage /></Layout>} />
          <Route path="/familias" element={<Layout><FamiliasPage /></Layout>} />
          <Route path="/filosofia" element={<Layout><FilosofiaPage /></Layout>} />
          <Route path="/bonos" element={<Layout><BonosPage /></Layout>} />
          <Route path="/reservar" element={<Layout><ReservarPage /></Layout>} />
          {/* Legacy redirects */}
          <Route path="/membresias" element={<Navigate to="/bonos" replace />} />
          <Route path="/reservas" element={<Navigate to="/reservar" replace />} />
          <Route path="/contacto" element={<Layout><ContactoPage /></Layout>} />
          <Route path="/regalo" element={<Layout><GiftVoucherPage /></Layout>} />
          <Route path="/bonos/pago-completado" element={<Layout><BonoPagoCompletadoPage /></Layout>} />
          <Route path="/bonos/pago-error" element={<Layout><BonoPagoErrorPage /></Layout>} />
          <Route path="/reservas/pago-completado" element={<Layout><BookingPagoCompletadoPage /></Layout>} />
          <Route path="/reservas/pago-error" element={<Layout><BookingPagoErrorPage /></Layout>} />
        </Routes>
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
